// utils/DateFormater.ts

export const formatDate = (dateString: string | number | Date): string => {
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return ""; // invalid date guard

  const day = date.getDate()?.toString()?.padStart(2, "0"); // 2-digit day
  const month = date.toLocaleString("en-US", { month: "short" }); // e.g., Aug
  const year = date.getFullYear();

  return `${day} ${month} ${year}`;
};


